// extracted by mini-css-extract-plugin
module.exports = {"w170x5fj":"w170x5fj"};